import { createApp } from 'vue'
// @ts-ignore
import App from '@/App.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import { onFatalError } from '@/services/GalleryLoadService'

declare global {
  interface Window {
    anzu: any
  }
}

const loadGallery = () => {
  // Check if gallery global window data exist
  if (!(window.anzu && window.anzu.gallery && window.anzu.gallery.data && window.anzu.gallery.config)) {
    onFatalError(new Error('Unable to load gallery global object.'))
    return
  }
  const app = createApp(App)
  app.use(VueEasyLightbox)
  app.mount('#app')
}

loadGallery()
